import { requestConfig } from '@/utils/request';
import { send } from './utils/Faq';
import { getLocale, setLocale } from 'umi';
import Cookie from 'js-cookie';

export const request = requestConfig;
function getBrowserVersionInfo() {
  const ua = navigator.userAgent;
  const browserInfo = {
    browser: 'unknown',
    version: 'unknown',
  };

  if (ua.indexOf('Firefox') !== -1) {
    browserInfo.browser = 'Firefox';
    browserInfo.version = ua.split('Firefox/')[1].split(' ')[0];
  } else if (ua.indexOf('Opera') !== -1 || ua.indexOf('OPR') !== -1) {
    browserInfo.browser = 'Opera';
    browserInfo.version = ua.split('Opera|OPR/')[1].split(' ')[0];
  } else if (ua.indexOf('MSIE') !== -1) {
    browserInfo.browser = 'IE';
    browserInfo.version = ua.split('MSIE ')[1].split(';')[0];
  } else if (ua.indexOf('Chrome') !== -1) {
    browserInfo.browser = 'Chrome';
    browserInfo.version = ua.split('Chrome/')[1].split(' ')[0].split('.')[0];
  } else if (ua.indexOf('Safari') !== -1) {
    browserInfo.browser = 'Safari';
    browserInfo.version = ua.split('Version/')[1].split(' ')[0];
  }

  return browserInfo;
}

export function render(oldRender) {
  const apollo = window.__SENTRY_CONFIG__.apollo;
  const { clusterName } = apollo;
  const currentLocale =
    Cookie.get('kava_locale') || clusterName === 'defalut'
      ? getLocale()
      : 'en-US';
  setLocale(currentLocale, false);

  oldRender();
  const browserInfo = getBrowserVersionInfo();
  send('client_open', {
    client_brand_info: browserInfo.browser,
    client_system_info: browserInfo.version,
    app_version: 'new',
    event_origin: 'id',
  });
}
let currentPathname = '/';
export function onRouteChange(props: any) {
  const { location } = props;
  if (currentPathname !== location.pathname) {
    console.log('[ location.pathname ] >', location.pathname);
    currentPathname = location.pathname;
    send('PageVisit', {
      $string_value: location.pathname,
      event_origin: 'id',
    });
  }
}
